import { useParams, Link } from 'react-router-dom';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { db } from './firebaseConfig';
import SEO from './SEO';
import {
  collection,
  addDoc,
  getDocs,
  query,
  orderBy,
  increment
} from 'firebase/firestore';
import { formatDistanceToNow } from 'date-fns';
import { es } from 'date-fns/locale';

function Perfil() {
  const { id } = useParams();
  const [publicacion, setPublicacion] = useState(null);
  const [loading, setLoading] = useState(true);
  const [imagenAmpliada, setImagenAmpliada] = useState(null);
  const [comentarios, setComentarios] = useState([]);
  const [alias, setAlias] = useState('');
  const [comentarioTexto, setComentarioTexto] = useState('');
  const [rating, setRating] = useState(0);
  const [promedioRating, setPromedioRating] = useState(null);

  useEffect(() => {
    const obtenerComentarios = async () => {
      const ref = collection(db, 'services', id, 'comentarios');
      const q = query(ref, orderBy('fecha', 'desc'));
      const snapshot = await getDocs(q);
      const docs = snapshot.docs.map(doc => doc.data());
      setComentarios(docs);

      const ratings = docs.map(c => c.rating).filter(Boolean);
      if (ratings.length > 0) {
        const suma = ratings.reduce((a, b) => a + b, 0);
        setPromedioRating((suma / ratings.length).toFixed(1));
      } else {
        setPromedioRating(null);
      }
    };

    obtenerComentarios();

    const obtenerDatos = async () => {
      try {
        const refDoc = doc(db, 'services', id);
        const snapshot = await getDoc(refDoc);

        if (snapshot.exists()) {
          const data = snapshot.data();
          setPublicacion(data);

          const vistasActuales = data.vistas || 0;
          await updateDoc(refDoc, { vistas: vistasActuales + 1 });
        }
      } catch (error) {
        console.error("Error al obtener publicación:", error);
      } finally {
        setLoading(false);
      }
    };

    obtenerDatos();
  }, [id]);



  const emojiPorRol = (rol) => {
    if (!rol) return '🎭';
    if (rol === 'Activo') return '🍆';
    if (rol === 'Pasivo') return '🍑';
    if (rol === 'Versátil') return '🔄';
    if (rol === 'Activo participativo') return '🍆✨';
    if (rol === 'Pasivo participativo') return '🍑✨';
    return '🎭';
  };

  if (loading) return <p className="p-4">Cargando publicación...</p>;
  if (!publicacion) return <p className="p-4">Publicación no encontrada.</p>;

  return (
    <div className="max-w-3xl mx-auto p-6">
      <SEO
        title={`${publicacion.nombre} - ${publicacion.categoria || 'Servicios'} en ${publicacion.ciudad || 'Chile'}`}
        description={`Perfil de ${publicacion.nombre}. ${publicacion.description ? publicacion.description.slice(0, 150) : 'Encuentra masajes, escorts y servicios exclusivos en VipEncuentros.'}`}
        image={publicacion.portadaUrl}
        keywords={`scort, ${publicacion.categoria}, ${publicacion.ciudad}, ${publicacion.nombre}, masaje, servicio`}
      />
      <Link to="/" className="text-blue-500 underline text-sm">&larr; Volver</Link>

      {/* Portada */}
      <div className="relative w-full h-72 rounded overflow-hidden shadow mb-6 mt-4">
        {publicacion.portadaUrl && (publicacion.portadaUrl.includes('.mp4') || publicacion.portadaUrl.includes('video')) ? (
          <video
            src={publicacion.portadaUrl}
            className="w-full h-full object-cover"
            autoPlay loop muted playsInline
          />
        ) : (
          <img
            src={publicacion.portadaUrl}
            alt="Portada"
            className="w-full h-full object-cover"
          />
        )}
        <div className="absolute bottom-0 left-0 bg-gradient-to-t from-black/80 to-transparent w-full p-4">
          <p className="text-white font-bold text-4xl drop-shadow">{publicacion.nombre}</p>
          <p className="text-white text-lg drop-shadow flex gap-2 items-center flex-wrap">
            {publicacion.ciudad && <>📍 {publicacion.ciudad}</>}
            {publicacion.rol && <>· {emojiPorRol(publicacion.rol)} {publicacion.rol}</>}
          </p>
        </div>
      </div>

      {/* Información adicional */}
      <div className="bg-neutral-800/80 backdrop-blur-md p-4 rounded-lg shadow text-sm text-gray-200 mb-6 space-y-2">
        {publicacion.edad && (
          <div className="flex items-center gap-2">
            <span>🎂</span> <span>Edad:</span> <strong>{publicacion.edad} años</strong>
          </div>
        )}
        {publicacion.altura && (
          <div className="flex items-center gap-2">
            <span>📏</span> <span>Altura:</span> <strong>{publicacion.altura} m</strong>
          </div>
        )}
        {publicacion.peso && (
          <div className="flex items-center gap-2">
            <span>⚖️</span> <span>Peso:</span> <strong>{publicacion.peso} kg</strong>
          </div>
        )}
        {publicacion.dotacion && (
          <div className="flex items-center gap-2">
            <span>🍆</span> <span>Dotación:</span> <strong>{publicacion.dotacion} cm</strong>
          </div>
        )}
        {publicacion.description && (
          <div className="flex items-start gap-2">
            <span>🗒️</span>
            <div className="space-y-2 text-justify">
              {publicacion.description.split('\n').map((linea, idx) => (
                <p key={idx}>{linea.trim()}</p>
              ))}
            </div>
          </div>
        )}
        {publicacion.whatsapp && (
          <div className="flex items-center gap-2">
            <span>📱</span> <span>WhatsApp:</span>
            <a
              href={`https://wa.me/${publicacion.whatsapp.replace(/\D/g, '')}?text=${encodeURIComponent(`Hola, vi tu perfil (${publicacion.nombre}) en VipEncuentros.com el sitio con los mejores chicos de la ciudad y me gustaría saber más.`)}`}
              target="_blank"
              rel="noopener noreferrer"
              onClick={async () => {
                try {
                  const refDoc = doc(db, 'services', id);
                  await updateDoc(refDoc, { whatsappClicks: increment(1) });

                  // Google Ads Conversion
                  if (typeof window.gtag === 'function') {
                    window.gtag('event', 'conversion', {
                      'send_to': 'AW-785877464/zZpOCJOn9_IbENiT3vYC',
                      'value': 1.0,
                      'currency': 'CLP'
                    });
                  }
                } catch (e) { console.error("Error tracking click", e); }
              }}
              className="text-blue-600 underline"
            >
              {publicacion.whatsapp}
            </a>
          </div>
        )}
        {publicacion.vistas !== undefined && (
          <div className="flex items-center gap-2">
            <span>👁️</span> <span>Vistas:</span> <strong>{publicacion.vistas}</strong>
          </div>
        )}
      </div>

      {/* Galería */}
      {publicacion.imageUrls && publicacion.imageUrls.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {publicacion.imageUrls.map((url, index) => (
            <div key={index} className="relative w-full h-85 cursor-pointer" onClick={() => setImagenAmpliada(url)}>
              {(url.includes('.mp4') || url.includes('video')) ? (
                <video
                  src={url}
                  className="w-full h-full object-cover rounded shadow transition duration-500 ease-in-out hover:scale-105"
                  controls
                  muted
                />
              ) : (
                <img
                  src={url}
                  alt={`Imagen ${index + 1}`}
                  className="w-full h-full object-cover rounded shadow transition duration-500 ease-in-out blur-sm hover:scale-105"
                  onLoad={(e) => e.currentTarget.classList.remove('blur-sm')}
                />
              )}
            </div>
          ))}
        </div>
      )}

      {/* Modal */}
      {imagenAmpliada && (
        <div
          className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4"
          onClick={(e) => {
            // No cerrar si hace click en el video (controles)
            if (e.target.tagName !== 'VIDEO') setImagenAmpliada(null);
          }}
        >
          <button 
            className="absolute top-4 right-4 text-white text-3xl font-bold bg-black/50 w-10 h-10 rounded-full flex items-center justify-center"
            onClick={() => setImagenAmpliada(null)}
          >
            &times;
          </button>
          {(imagenAmpliada.includes('.mp4') || imagenAmpliada.includes('video')) ? (
            <video
              src={imagenAmpliada}
              className="max-w-full max-h-[90vh] rounded shadow-lg"
              controls
              autoPlay
            />
          ) : (
            <img
              src={imagenAmpliada}
              alt="Imagen ampliada"
              className="max-w-4xl max-w-full max-h-[90vh] rounded shadow-lg"
            />
          )}
        </div>
      )}

      {/* WhatsApp */}
      {publicacion.whatsapp && (
        <a
          href={`https://wa.me/${publicacion.whatsapp.replace(/\D/g, '')}?text=${encodeURIComponent(`Hola, vi tu perfil (${publicacion.nombre}) en VipEncuentros.com el sitio con los mejores chicos de la ciudad y me gustaría saber más.`)}`}
          target="_blank"
          rel="noopener noreferrer"
          onClick={async () => {
            try {
              const refDoc = doc(db, 'services', id);
              await updateDoc(refDoc, { whatsappClicks: increment(1) });

              // Google Ads Conversion
              if (typeof window.gtag === 'function') {
                window.gtag('event', 'conversion', {
                  'send_to': 'AW-785877464/zZpOCJOn9_IbENiT3vYC',
                  'value': 1.0,
                  'currency': 'CLP'
                });
              }
            } catch (e) { console.error("Error tracking click", e); }
          }}
          className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-full shadow-lg z-40 transition flex items-center gap-2 min-w-[130px]"
        >

          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M20.52 3.48A11.91 11.91 0 0012 0a11.9 11.9 0 00-8.48 3.52A11.87 11.87 0 000 12a11.8 11.8 0 001.65 6.1L0 24l6.14-1.62A11.9 11.9 0 0012 24a11.9 11.9 0 008.48-3.52A11.9 11.9 0 0024 12a11.87 11.87 0 00-3.48-8.52zM12 21.6a9.6 9.6 0 01-4.91-1.32l-.35-.21-3.63.96.97-3.55-.23-.37A9.59 9.59 0 012.4 12a9.6 9.6 0 0116.4-6.8A9.6 9.6 0 0121.6 12 9.61 9.61 0 0112 21.6zm5.06-7.44l-2.24-.64a.83.83 0 00-.8.21l-.6.62a7.08 7.08 0 01-3.36-3.35l.63-.6a.83.83 0 00.21-.8l-.64-2.25a.84.84 0 00-1-.58 5.86 5.86 0 00-2.8 1.9c-.33.4-.66.85-.66 1.38 0 .33.12.66.29.95a12.08 12.08 0 0010.26 6.63c.53 0 .98-.32 1.38-.65a5.88 5.88 0 001.91-2.8.83.83 0 00-.58-1z" />
          </svg>
          <span className="hidden sm:inline">WhatsApp</span>
        </a>
      )}

      {/* Comentarios */}
      <div className="mt-10">
        <h3 className="text-xl font-bold mb-3">💬 Dejar un comentario</h3>
        <form
          onSubmit={async (e) => {
            e.preventDefault();
            if (!alias || !comentarioTexto || rating === 0) return;

            try {
              const nuevoComentario = {
                alias,
                texto: comentarioTexto.slice(0, 300),
                fecha: new Date(),
                rating
              };

              await addDoc(collection(db, 'services', id, 'comentarios'), nuevoComentario);
              setComentarios(prev => [nuevoComentario, ...prev]);
              setAlias('');
              setComentarioTexto('');
              setRating(0);
              alert('¡Comentario enviado con éxito!');
            } catch (error) {
              console.error("Error al enviar comentario:", error);
              alert("Error al enviar: " + error.message + "\n\n(Es probable que necesites ajustar los permisos en Firebase Console)");
            }
          }}
          className="space-y-3 bg-neutral-900/70 p-4 rounded-lg shadow-lg"
        >
          <input
            className="w-full bg-neutral-800 text-white border border-neutral-600 p-2 rounded"
            placeholder="Tu alias"
            value={alias}
            onChange={(e) => setAlias(e.target.value)}
            required
          />
          <div className="flex gap-1">
            {[1, 2, 3, 4, 5].map((star) => (
              <button
                key={star}
                type="button"
                onClick={() => setRating(star)}
                className={`text-2xl ${star <= rating ? 'text-yellow-400' : 'text-gray-500'}`}
              >
                ★
              </button>
            ))}
          </div>
          <textarea
            className="w-full bg-neutral-800 text-white border border-neutral-600 p-2 rounded"
            placeholder="Tu comentario (máx. 300 caracteres)"
            value={comentarioTexto}
            onChange={(e) => setComentarioTexto(e.target.value)}
            maxLength={300}
            required
          />
          <button className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded font-semibold" type="submit">
            Enviar
          </button>
        </form>

        {comentarios.length > 0 && (
          <div className="mt-8 space-y-4">
            {promedioRating && (
              <div className="flex items-center gap-2 text-yellow-400 text-lg mb-2">
                {Array.from({ length: 5 }, (_, i) => (
                  <span key={i}>{i < Math.round(promedioRating) ? '★' : '☆'}</span>
                ))}
                <span className="text-sm text-gray-300 ml-2">
                  {promedioRating} de 5 · {comentarios.length} voto{comentarios.length > 1 ? 's' : ''}
                </span>
              </div>
            )}

            <h4 className="text-md font-semibold text-gray-200">Comentarios recientes:</h4>
            {comentarios.map((c, i) => (
              <div key={i} className="border border-neutral-700 p-4 rounded-lg bg-neutral-800/80 shadow-sm">
                <div className="flex items-center justify-between mb-1">
                  <span className="text-sm font-semibold text-white">{c.alias}</span>
                  <span className="text-xs text-gray-400">
                    {c.fecha?.toDate ? formatDistanceToNow(c.fecha.toDate(), { addSuffix: true, locale: es }) : ''}
                  </span>
                </div>
                {c.rating && (
                  <div className="text-yellow-400 text-sm mb-2">
                    {Array.from({ length: 5 }, (_, j) => (
                      <span key={j}>{j < c.rating ? '★' : '☆'}</span>
                    ))}
                  </div>
                )}
                <p className="text-sm text-gray-100">{c.texto}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Perfil;


